import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import Handlebars from "vendor/handlebars";
import hbs from "vendor/handlebars";
import handlebarsRuntime from "vendor/handlebars-runtime";
import hb from "vendor/handlebars-runtime";




export default {




  disableModule () {
    this.$target.addClass('hide');
  },




  enableModule () {
    this.$target.removeClass('hide');
  },




  fadeOutModule() {


    this.$target.fadeOut(1000);


    this.$target.removeClass('todo-active');
  },





  formatPrice (amountBorrowed) {


    var dollarFormat = amountBorrowed.toString().split('.');


    if (dollarFormat[0].length >= 5) {
      dollarFormat[0] = dollarFormat[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }


    if (dollarFormat[1] && dollarFormat[1].length >= 5) {
      dollarFormat[1] = dollarFormat[1].replace(/(\d{3})/g, '$1 ');
    }


    return dollarFormat.join('.');

  },






  formatZip (zipCode){


    if (zipCode === undefined) {
      zipCode = '';
    }


    var zipFormat = zipCode.slice(0, 5);


    return zipFormat.replace(/[^0-9]/g, '');

  },





  bindAllMethod () {


    let methods = Object.getOwnPropertyNames(Object.getPrototypeOf(this));


    let loopThroughMethods = method => {
      this[method] = this[method].bind(this);
    };


    methods = methods.slice(1, -1);


    methods.forEach(loopThroughMethods);

  },





  dropdownToggle ($dropdown, $arrow) {

    return () => {


      $dropdown.slideToggle('slow');


      $arrow.toggleClass('rotate-up rotate-down');

    };

  },






  getQueryParamValues(url) {
    const pattern = /([^\/\?\&\=]+\=[^\&\#]+)/g;
    const matches = url.match(pattern);
    return matches && _.fromPairs(matches.map(pair => pair.split('=').map(encodeURIComponent)));
  },







  inputRemovePatternDataAttr (selector) {
    let $selector = $ (selector );
    $selector.find('input').each(function(idx, val){
      let $val = $(val);
      $val.removeAttr('data-default-pattern').attr('data-default-pattern', '.*').removeAttr('pattern');
    });

  },







  updatePartial ( state, partialId, elementClass, helpers = null ) {


      const $partial = $( partialId );


      if ( !$partial.length ) {
          return false;
      }


      const html = $partial.html();

      if (helpers) {
        for (let helper in helpers) {
                if (helpers.hasOwnProperty(helper)) {
                    hbs.registerHelper(helper, helpers[helper]);
                }
        }
      }


      const hbsTemplate = hbs.compile( html );


      const source = hbsTemplate( state );


      $( elementClass ).html( source );

  },







  spartaInputHack($target) {
    const fix = () => {
      $target.find('.spa-input').each(function () {
        const $duplicateDropdowns = $(this).siblings('.input-help:not(:first)');
        $duplicateDropdowns.remove();
        const $duplicateTriggers = $(this).children('.toggle-trigger:not(:last)');
        $duplicateTriggers.remove();
      });
    };
    setTimeout(fix, 2000);
  },






  toTitleCase(words) {
    return words.split(' ').map((word) => word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  },





  caseWord (str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },







  replaceTokens($element, context) {
    const traverseTo = (o, path) => {
      return _.reduce(path, (memo, segment) => memo && memo[segment], o);
    }
    const formatValue = (value, type = 'string') => {
      switch (type) {
        case 'currency':
          const formatted = value && (new Number(value)).toLocaleString();
          return `\$${formatted || 'XXX,XXX'}`;
        case 'date':

          return value ? value : (new Date()).toLocaleDateString();
        case 'percentage':
          return `${value ? (new Number(value)).toFixed(3) : 'X.XXX'}%`;
        case 'zipcode':
          return value ? value.slice(0, 5) : 'XXXXX';
        default:
          return value;
      }
    }
    const $tokens = $element.find('.convert');
    $tokens.each(function () {
      const $token = $(this);
      const key = $token.data('token');
      if (key) {
        const value = traverseTo(context, key.split('.'));
        const formatted = formatValue(value, $token.data('type'));
        if (formatted || formatted === 0) {
          $token.html(formatted);
        }
      }
    });
  },







  registerHandlebarsHelpers(handlebars, helpers) {
    for (var helper in helpers) {
      if (helpers.hasOwnProperty(helper)) {
        handlebars.registerHelper(helper, helpers[helper]);
      }
    }
  },

  render($elements, context, handlebars, renderedList) {
    $elements.each(function () {
      const $instance = $(this);
      const id = $instance.attr('id');
      if (!renderedList[id]) {
        renderedList[id] = true;
        const template = $instance.html();
        const templateFunction = handlebars.compile(template);
        const html = templateFunction(context);
        $instance.html(html);
      }
    });
  },

  toggleContent($elements, condition) {
    if (condition) {
      $elements.show();
    } else {
      $elements.hide();
    }
  },









  moduleToggler(...toggleObj){
    const self = this;
    let $el;
    let currentShowObj;
    let len = toggleObj.length - 1;
    let command = (typeof toggleObj[0] === 'string' && (toggleObj[0] === 'show' || toggleObj[0].indexOf('hide') !== -1)) ? toggleObj[0] : undefined;

    $.fn.toggleAll = function (command) {
      $el = $(this);
      const visible = () => {
        return $el.css('visibility') !== 'hidden';
      };
      const displayed = () => {
        return $el.css('display') !== 'none';
      };
      const opaque = () => {
        return $el.css('opacity') !== '0';
      };
      if (displayed() && visible() && !opaque()) {
        $el.css({'opacity': '1'});
      } else if (displayed() && opaque() && !visible()) {
        $el.css({'visibility': 'show'});
      } else {
        if (command && command.indexOf('hide') !== -1) {
          $el.hide();
          if (command.indexOf('andclear' !== -1)) {
            self.clearInputs($el);
          }
        } else if (command && command === 'show') {
          $el.show();
        } else {
          $el.toggle();
        }
      }
    };

    toggleObj.map((obj, i) => {
      if (typeof obj !== "function") {
        currentShowObj = obj;
        this.getParentModule(obj).toggleAll(command);
      } else if (i === len) {  
        if (obj.Events && typeof obj.Events === 'object' && Object.keys(obj.Events._store).length >= 0) {

          obj.Events.pub('module-toggler-called', currentShowObj);
        } else {
          obj($el);  
        }
      }
    });
  },

  clearInputs($el) {
    const moduleInputs = $el.find(':input');
    moduleInputs.map((i, obj) => {
      $(obj).val("");
      $(obj).prop('checked', false);
    });
  },

  isJqueryEl(el) {  
    return ('jquery' in Object(el)) ? true : false;
  },

  isPlainArray(el) {  
    return (el && el.constructor === Array && !this.isJqueryEl(el)) ? true : false;
  },

  isSpartaModule(el) {  
    return (this.isJqueryEl(el) && typeof el.attr('data-component') === "module") ? true : false;
  },

  getParentModule(el) {  
    if (!this.isSpartaModule(el)) {
      if (!this.isJqueryEl(el)) {
        el = $(el);
      }
      el = el && el.closest('div[data-component="module"]')
    }
    return el;
  },

  lowerTrimString(key) {  
    return key.split(' ').join('').toLowerCase();
  },

  lowerTrimObjectKeys(obj) {  
    return Object.assign(
      {},
      ...Object.keys(obj).map(key => ( {[this.lowerTrimString(key)]: obj[key]}))
    );
  },
  arrayDiff(a, b) {  
    const diffIndexes = [];
    return b.filter(function (i) {
      if (a.indexOf(i) < 0) {
        diffIndexes.push(b.indexOf(i));
        return true;
      } else {
        return false;
      }
    });
  },

  handlebarsHelpers: {
    eq: (left, right, options) => {
      return left === right ? options.fn(this) : options.inverse(this);
    },
    currency: (value) => {
      const numericValue = new Number(value);
      if (numericValue < 1) {
        return value;
      }

      let formatted = (value || value === 0) && (new Number(value)).toFixed(2).replace(/./g, function (character, index, amount) {
          return index && character !== "." && ((amount.length - index) % 3 === 0) ? ',' + character : character;
        });

      return `\$${formatted || 'XXX,XXX'}`;
    },
    currencyRoundedInt: (value) => {
      const numericValue = new Number(value);
      if (numericValue < 1) {
        return value;
      }

      let formatted = (value || value === 0) && (new Number(value)).toFixed().replace(/./g, function (character, index, amount) {
          return index && character !== "." && ((amount.length - index) % 3 === 0) ? ',' + character : character;
        });

      return `\$${formatted || 'XXX,XXX'}`;
    },
    date: (value) => {
      return value ? value : (new Date()).toLocaleDateString();
    },
    percentage: (value) => {
      return `${value ? (new Number(value)).toFixed(3) : 'X.XXX'}%`;
    },
    zipcode: (value) => {
      return value ? value.slice(0, 5) : 'XXXXX';
    },
    getCustomFormattedDate: (value, monthDay, dayMonth) => {
      let pad = '00';
      let dt = new Date(value);
      let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let day = '' + dt.getDate();
      day = pad.substring(0, pad.length - day.length) + day;
      let month = monthNames[dt.getMonth()];
      let year = dt.getFullYear();
      let hour = dt.getHours() % 12;
      hour = hour ? '' + hour : '12';
      hour = pad.substring(0, pad.length - hour.length) + hour;
      let min = '' + dt.getMinutes();
      min = pad.substring(0, pad.length - min.length) + min;
      let amPM = 12 - dt.getHours() > 0 ? 'am' : 'pm';
      let timeZone = dt.toString().match(/(\()(.*)(\))/)[2];
      let spanish = /\/es/.test(window.location.pathname);
      if (spanish){
        let mappings = {'eastern': 'hora del este', 'pacific': 'tiempo de pacifico',
                       'central' : 'hora del centro', 'mountain': 'hora de la montaña',
                       'hawaii': 'hora del Hawaii' };

        for(let key in mappings){
          if (timeZone.toLowerCase().includes(key)){
            timeZone = mappings[key];
            break;
          }
        }

      }
      if (monthDay){
        return `${month} ${day} ${year} ${hour}:${min} ${amPM} ${timeZone}`;
      }
      else if (dayMonth){
        return `${day} ${month} ${year} ${hour}:${min} ${amPM} ${timeZone}`;
      }
      else{
        return `${day} ${month} ${year} ${hour}:${min} ${amPM} ${timeZone}`;
      }

    }
  }

}


